/**
 * A nonprofit browsing an open donation doesn't see who it's from until it
 * claims (#249). The API marks those donations with `is_donor_hidden`, leaves
 * the donor's name, contacts and team out, and gives an approximate pickup
 * point within `approximate_radius_m` of the real one.
 */

/** @param {object | null | undefined} donation */
export const isDonorHidden = (donation) => Boolean(donation?.is_donor_hidden);

/**
 * What to call a hidden donor: its business type ("Grocery Store"), else a
 * generic label.
 * @param {object | null | undefined} donation
 * @param {(key: string, options?: object) => string} t
 */
export const getHiddenDonorLabel = (donation, t) => {
  const type = donation?.donor_business_type;
  return type
    ? t(`organization.type-values.${type}`, { defaultValue: type })
    : t('donations.hidden-donor', { defaultValue: 'Donor' });
};

/**
 * Radius in meters of the area to draw around an approximate pickup point,
 * or null when the point is exact.
 * @param {object | null | undefined} donation
 */
export const getApproximateRadius = (donation) => {
  const radius = Number(donation?.approximate_radius_m);
  return Number.isFinite(radius) && radius > 0 ? radius : null;
};

/**
 * Marks a formatted distance as approximate ("~3mi") when it's measured to an
 * approximate point.
 * @param {object | null | undefined} donation
 * @param {string} formatted
 */
export const markApproximateDistance = (donation, formatted) =>
  getApproximateRadius(donation) && donation?.distance != null
    ? `~${formatted}`
    : formatted;
